<template>
  <div id="tumorConferenceFormContent" class="flex layout-column pa-1" style="overflow-y: auto;">
    <div>
      <lx-expansion-panels :single-open="false" v-model="panel">

        <!--   Melder  (panel 0)   -->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(0, 'report_header')">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-account-edit"
                                     :main-headline="$t('FORMS_DIVERSE.REPORTER_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.REPORTER_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="report_header">
              <div class="pa-4 layout-row layout-wrap">
                <melder path="report_header"
                        :isMedicalCommunity="isMedicalCommunity"
                        :isDisabled="isFormDisabled()"
                        :validationRef="validationRef"
                        v-model="model.report_header"
                        :additionalItemsList="additionalItemsList"
                        class="layout-row layout-wrap flex-gt-sm-100 flex-100"></melder>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Grunddaten  Tumorkonferenz  (panel 1) -->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(1, 'base')">
          <lx-expansion-panel-header :disabled="true"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_HEADER')"
                                     icon="forum"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="base">
              <div class="pa-4 layout-row layout-wrap">
                <base-data path="base"
                           :key="'BaseDataTumorConference' + formId"
                           :reportHeader="model.report_header"
                           :patientId="patientId"
                           :formId="formId"
                           :validationRef="validationRef"
                           :addRecommendationItem="addItem"
                           :isDisabled="isFormDisabled()"
                           v-model="model.base"
                           class="layout-row layout-wrap flex-gt-sm-100 flex-100"></base-data>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Anmerkung   (panel 2) -->

        <lx-expansion-panel :isInvalid="openInvalidModule(2, 'anmerkung')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.MODULE_TUMOR_CONFERENCE_TEXT')"
                                     :sub-headline="$t('FORMS_DIVERSE.ANNOTATION_SUB_LINE')"
                                     icon="mdi-lead-pencil">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="anmerkung">
              <div class="px-4 pt-4 layout-row layout-wrap">
                <anmerkung path="anmerkung"
                           :isDisabled="isFormDisabled()"
                           v-model="model.anmerkung"
                           class="layout-wrap flex-gt-sm-100 flex-100"></anmerkung>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>
      </lx-expansion-panels>
    </div>
  </div>
</template>

<script>
import utils from '../../../common/utils'

import baseData from '../shared/GrunddatenTumorkonferenz'
import anmerkung from '../shared/Anmerkung'
import melder from '../shared/Melder'
import lodash from 'lodash'

export default {
  name: 'TumorConference',
  mixins: [utils],
  components: {
    baseData,
    anmerkung,
    melder
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    modulesAreEmpty: {
      type: Object,
      default: () => ({})
    },
    // is used to mark headers of invalid modules after trying to complete form (function in utils)
    setIsCompletedIsTriggered: {
      type: Boolean,
      default: false
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    patientId: {
      type: String
    },
    additionalItemsList: {
      type: Array,
      default: () => ([])
    },
    formId: {
      type: String
    }
  },
  data () {
    return {
      model: {
        key: 'tumorConference'
      },
      panel: []
    }
  },
  created () {
    this.panel = lodash.clone(this.modulesAreEmpty.defaultPanel)
  },
  computed: {
    isMedicalCommunity () {
      const user = this.authStore.getters.getAuthUserData && this.authStore.getters.getAuthUserData.user ? this.authStore.getters.getAuthUserData.user : {}
      return user.cancer_form_details && user.cancer_form_details.isMedicalCommunity
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue

          // scroll to top, if new form
          if (!this.formId) {
            const myDiv = document.getElementById('tumorConferenceFormContent')
            if (myDiv) {
              myDiv.scrollTop = 0
            }
          }
        }
      },
      immediate: true
    },
    'model.base.tumorConferenceTypesListItem': {
      handler: function (newValue, oldValue) {
        // set report reason and type of conference only after changing value and form is not disabled
        if (newValue && newValue !== oldValue && !this.isFormDisabled()) {
          this.model.report_header = this.model.report_header || {}
          this.model.report_header.meldeanlass = ''

          // set typ and report reason in dependency to value of tumorConferenceTypesListItem
          switch (newValue) {
            case 'praethDiagnosis':
              this.model.report_header.meldeanlass = 'diagnose'
              this.model.base.tumorkonferenz_typ = 'praeth'
              break
            case 'praethTreatment':
              this.model.report_header.meldeanlass = 'behandlungsbeginn'
              this.model.base.tumorkonferenz_typ = 'praeth'
              break
            case 'praethState':
              this.model.report_header.meldeanlass = 'statusaenderung'
              this.model.base.tumorkonferenz_typ = 'praeth'
              break
            case 'postop':
              this.model.report_header.meldeanlass = 'behandlungsende'
              this.model.base.tumorkonferenz_typ = 'postop'
              break
            case 'therDiagnosis':
              this.model.report_header.meldeanlass = 'diagnose'
              this.model.base.tumorkonferenz_typ = 'ther'
              break
            case 'therTreatment':
              this.model.report_header.meldeanlass = 'behandlungsbeginn'
              this.model.base.tumorkonferenz_typ = 'ther'
              break
            case 'therState':
              this.model.report_header.meldeanlass = 'statusaenderung'
              this.model.base.tumorkonferenz_typ = 'ther'
              break
            default:
              // default is postth
              this.model.report_header.meldeanlass = 'behandlungsende'
              this.model.base.tumorkonferenz_typ = 'postth'
          }

          // set validation field of tumorkonferenz_typ on dirty to trigger auto-save because of programmatically change
          if (this.validationRef?.fields && this.validationRef.fields['base.tumorkonferenz_typ']) {
            this.$nextTick(() => {
              this.validationRef.fields['base.tumorkonferenz_typ'].changed = true
            })
          }
        }
      },
      immediate: true
    }
  }
}
</script>

